import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/app/model/store';

export const selectCounters = createSelector(
  (
    state: RootState,
  ): {
    accessSharedWithMeCount: number;
    accessSharedByMeCount: number;
    accessTotalOrganizationPatientCount: number;
  } => ({
    accessSharedWithMeCount: state.access.accessSharedWithMeCount,
    accessSharedByMeCount: state.access.accessSharedByMeCount,
    accessTotalOrganizationPatientCount:
      state.access.accessTotalOrganizationPatientCount,
  }),
  (counters) => counters,
);
